import { Fetch } from "@lucaswickstrom/fetch";
const skolverketPlannedEducations = new Fetch({
    baseUrl: process.env.SKOLVERKET_API,
    headers: {
        Accept: "application/vnd.skolverket.plannededucations.api.v3.hal+json",
    },
});
const skolverketRegistry = new Fetch({
    baseUrl: process.env.SKOLVERKET_API,
    headers: {
        Accept: "application/json",
    },
});
export const getSchools = (params) => skolverketPlannedEducations.get("/planned-educations/school-units", { params });
export const getSchool = (schoolUnitCode) => skolverketRegistry
    .get(`/skolenhetsregistret/v2/school-units/${schoolUnitCode}`)
    .then(({ data }) => {
    const address = data.attributes.addresses.find((addr) => addr.type === "BESOKSADRESS") ?? data.attributes.addresses[0];
    return {
        body: {
            name: data.attributes.displayName,
            contactInfo: {
                addresses: address
                    ? [
                        {
                            type: "VISITING_ADDRESS",
                            street: address.streetAddress,
                            zipCode: address.postalCode,
                            city: address.locality,
                        },
                    ]
                    : [],
            },
            geographicalAreaCode: data.attributes.municipalityCode,
        },
    };
});
//# sourceMappingURL=getSchool.js.map